<template lang="pug">
  nav.navbar.navbar-expand.flex-md-column.flex-row.align-items-start.custom-v-navbar
    .collapse.navbar-collapse
      ul.flex-md-column.flex-row.navbar-nav.w-100.justify-content-between
        li.nav-item().p-2
            b
              a.nav-link(href='/') 
                img(src="@/assets/imgs/logo.svg").my-2
        li.nav-item().p-2
            b
              a.nav-link(href='/') Dashboard
        //- li.nav-item().p-2
        //-     b
        //-       a.nav-link(href='/logs') Logs
        //- li.nav-item().p-2
        //-     b
        //-       a.nav-link(href='/') Documentation
        //- li.nav-item().p-2
        //-     b
        //-       a.nav-link(href='/') Contact us
        li.nav-item.p-2(v-if="user")
            b
              a.nav-link(@click="logOut()") Logout

        li.nav-item.p-2(v-if="!user")
            b
              a.nav-link(href='/login') Login
</template>

<script>
import {Auth} from '../../helpers'
export default {
  name: 'VNavigation',
  props:{},
  watch: {
      '$route'(){
          this.activeLink = this.$route.meta.activeLink
      }
  },
  data () {
    return {
        user: Auth.user,
        info: null,
        activeLink: null
    }
  },
  mounted () {
      this.activeLink = this.$route.meta.activeLink
  },
  methods: {
    logOut(){
      Auth.logOutUser();
      window.location.href = "/"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
 nav {
     padding: 0;
 }
 .nav-link {
   cursor: pointer;
   color: black;
   font-size: 18px;
 }

</style>
